import { IconProps } from '@models/icons';

function ArrowLineDown({ size = 30, color = '#6E6864', ...rest }:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M23.5 12L15.5 18L7.5 12"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default ArrowLineDown;
